import React, {useEffect, useState} from 'react';
import TaskDeaList, {TaskDeaListResponse} from './ws/TaskDeaList';
import {GoogleMap} from '../../components/googleMap/GoogleMap';
import {LoadingView, FilterState} from '@cuatroochenta/co-admin-react-library';

interface Props {
    filter: FilterState
}

const DeaMapList = (props: Props): React.ReactElement => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [coordinates, setCoordinates] = useState<
        { latitude: number; longitude: number; title: string }[]
    >([]);
    const noFilter = !props.filter ||
        (Object.values(props.filter.filters).length === 0) ||
        (Object.values(props.filter.filters).filter(value => value !== '').length === 0);

    useEffect(() => {
        if (!noFilter) {
            getDeaList(props.filter.filters);
        }
    }, [props.filter]);

    const getDeaList = (filters: { [key: string]: string }): void => {
        setIsLoading(true);
        let deas: { latitude: number, longitude: number, title: string }[] = [];
        new TaskDeaList({order: 'ASC', orderBy: 'Dea.name', filters})
            .onSuccess((data: TaskDeaListResponse) => {
                deas = data.results.map((result: any) => ({
                    latitude: result.locationLatitude,
                    longitude: result.locationLongitude,
                    title: result.name
                }));
                setCoordinates(deas);
                setIsLoading(false);
            })
            .onFail(() => setIsLoading(false))
            .execute();
    }

    if (noFilter) {
        return <p>No hay ningún filtro aplicado. Se debe seleccionar algún filtro para mostrar el mapa.</p>
    }

    if (isLoading) {
        return <LoadingView loading={true}/>
    }

    if (!coordinates || coordinates.length === 0) {
        return <p>No hemos encontrado resultados para la búsqueda seleccionada.</p>
    }

    return <GoogleMap coordinates={coordinates} zoom={8}/>;
};

export default DeaMapList;